import React from "react";
import Svg, {
  Path,
  Defs,
  LinearGradient,
  Stop,
  Rect,
  G,
  ClipPath,
} from "react-native-svg";
import { uniqueId } from "lodash";

export default function CloudIcon(props) {
  const filterId = "paint0_linear" + uniqueId();
  const gradientId = "paint0_linear_operation" + uniqueId();
  const filterUrl = "url(#" + filterId + ")";
  const gradientUrl = "url(#" + gradientId + ")";

  const width = props.width || 24;
  const height = props.height || 24;

  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G clipPath={filterUrl}>
        <Path
          d="M13.9394 3.54983C12.0161 3.54501 10.1492 4.19935 8.64968 5.40386C7.15021 6.60836 6.10872 8.29029 5.69873 10.1694C4.44715 10.4426 3.34044 11.1681 2.59078 12.2069C1.84113 13.2456 1.5013 14.5246 1.63646 15.7985C1.77161 17.0724 2.37223 18.2515 3.32316 19.1099C4.27409 19.9683 5.5084 20.4454 6.78943 20.4498H13.9394C16.1805 20.4498 18.3298 19.5596 19.9145 17.9749C21.4992 16.3902 22.3894 14.2409 22.3894 11.9998C22.3894 9.75875 21.4992 7.60946 19.9145 6.02478C18.3298 4.4401 16.1805 3.54983 13.9394 3.54983ZM9.87173 9.91008C10.5959 9.17758 11.5805 8.76133 12.6105 8.7522C13.6405 8.74307 14.6324 9.14179 15.3694 9.86133L16.5498 8.64193V11.9998H13.2998L14.4659 10.7947C14.101 10.4356 13.638 10.1923 13.1352 10.0957C12.6323 9.99904 12.1122 10.0533 11.6401 10.2516C11.168 10.4499 10.7651 10.7834 10.4822 11.2101C10.1992 11.6369 10.0488 12.1378 10.0498 12.6498H8.74983C8.74619 11.624 9.14967 10.6387 9.87173 9.91008V9.91008ZM12.6498 17.1998C11.6332 17.1966 10.6576 16.7985 9.92893 16.0896L8.74983 17.3077V13.9498H11.9998L10.8331 15.1549C11.1982 15.5137 11.6612 15.7566 12.164 15.853C12.6667 15.9494 13.1867 15.8951 13.6587 15.6969C14.1306 15.4986 14.5335 15.1653 14.8166 14.7389C15.0997 14.3124 15.2504 13.8117 15.2498 13.2998H16.5498C16.5488 14.3339 16.1376 15.3252 15.4064 16.0564C14.6752 16.7876 13.6839 17.1988 12.6498 17.1998V17.1998Z"
          fill={gradientUrl}
        />
      </G>
      <Defs>
        <LinearGradient
          id={gradientId}
          x1="1.60742"
          y1="7.21487"
          x2="8.68633"
          y2="25.0018"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#05858A" />
          <Stop offset="1" stopColor="#2AE8CB" />
        </LinearGradient>
        <ClipPath id={filterId}>
          <Rect
            width="20.8"
            height="20.8"
            fill="white"
            transform="translate(1.59961 1.59961)"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
}
